<template>
  <div class="d-flex ga-4">
    <div
      v-for="tag in tags"
      :key="tag.name"
      :style="{ backgroundColor: tag.color }"
      class="tag"
    >
      {{ tag.name }}
    </div>
  </div>
</template>

<script setup>
// import { defineProps } from 'vue'

defineProps({
  tags: {
    type: Array,
    required: true,
  },
})

</script>

<style lang="scss" scoped>

.tag {
  font-size: 14px;
  line-height: 16px;
  color: rgb(var(--v-theme-brandWhite));
  padding: 2px 9px;
  border-radius: 3px;
}
</style>
